import { PageAttr } from "../../../../shared/domain/entities/fetch-entities";
// @ts-expect-error - No declaration is required - TODO: - Stop using when the project is migrated.
import { REACT_APP_BACKEND_COMMON_URL } from "@env";
import { useConcatPages } from "../../../../shared/infrastructure";
import { useFetch } from "../../../../public/auth/infrastructure/store/fetch-context";
import { CommodityT, UseGetCommodityFilters } from "../../domain";
import {
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  useInfiniteQuery,
} from "@tanstack/react-query";

const commodityKeys = {
  all: ["commodities"] as const,
  commodities: () => [...commodityKeys.all, "commodities-list"] as const,
  commoditiesList: (filters: UseGetCommodityFilters) =>
    [...commodityKeys.commodities(), filters] as const,
};

const COMMODITIES_ENDPOINT = "commodities";

const useInfiniteGetCommodities = (
  filters: UseGetCommodityFilters,
  config: UseInfiniteQueryOptions<PageAttr<CommodityT>> = {}
): UseInfiniteQueryResult<PageAttr<CommodityT>> & {
  allPages: PageAttr<CommodityT>["data"];
} => {
  const fetch = useFetch();

  const response = useInfiniteQuery<PageAttr<CommodityT>>(
    commodityKeys.commoditiesList(filters),
    async ({ pageParam: page = 1 }: { pageParam?: number }) => {
      const response = await fetch.get<PageAttr<CommodityT>>(
        COMMODITIES_ENDPOINT,
        {
          baseURL: REACT_APP_BACKEND_COMMON_URL as string,
          params: {
            page,
            limit: 10,
            ...filters,
          },
        }
      );

      return response.data;
    },
    {
      ...config,
      getNextPageParam: (lastPage, allPages) =>
        lastPage.data.length > 0 ? allPages.length + 1 : undefined,
    }
  );

  const allPages = useConcatPages(response.data?.pages ?? []);

  return {
    ...response,
    allPages,
  };
};

export { commodityKeys, useInfiniteGetCommodities };
